export function initForm() {
    for (const formWrapper of document.querySelectorAll('.form')) {
        const form = formWrapper.querySelector('form');

        /** @type {Map<string, HTMLInputElement | HTMLSelectElement>} */
        const fieldMap = new Map();

        for (const element of form.querySelectorAll('[name]')) {
            const cleanKey = element.name.match(/tx_form_formframework\[[a-zA-Z\d-_]+]\[(?<field>[a-zA-Z\d-_]+)]+/)?.groups.field;
            if (!cleanKey) {
                continue;
            }
            fieldMap.set(cleanKey, element);
        }

        const toggledElements = formWrapper.querySelectorAll('[data-condition]');
        /** @type {{element: HTMLInputElement | HTMLSelectElement, requiredInputs: NodeListOf<(HTMLInputElement | HTMLSelectElement)>}[]} */
        const toggledElementsEntries = [];
        for (const element of toggledElements) {
            toggledElementsEntries.push({
                element,
                requiredInputs: element.querySelectorAll('[required]'),
            });
        }

        function execute() {
            const data = new FormData(form);
            for (const {element, requiredInputs} of toggledElementsEntries) {
                const [source, targetValue] = element.dataset.condition
                    .split('==')
                    .map(i => i.trim());

                const value = data.get(fieldMap.get(source).name);
                element.hidden = targetValue !== value;

                for (const input of requiredInputs) {
                    input.required = !element.hidden;
                }
            }
        }

        execute();

        form.addEventListener('change', () => {
            execute();
        });
    }
}
